// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1uHIU","buttons":"SendReceipts_buttons__xug42","email":"SendReceipts_email__3JS_b","bookApptTitle":"SendReceipts_bookApptTitle__ZFRhR"};